export default {
  'menu.welcome': 'Welcome',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.admin.settings': 'System Settings',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.register-result': 'Register Result',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
  'menu.datacenter3d': '3D Data Center',
  'menu.digital-twin-screen': 'Digital Twin Screen',
  'menu.resource-tree': 'Resource Tree',
  'menu.layout': 'Datacenter Layout',
  'menu.cabinet3d': 'Cabinet 3D',
  'menu.idc': 'Resource Management',
  'menu.idc.datacenter': 'Data Center',
  'menu.idc.cabinet': 'Cabinet Management',
  'menu.idc.device': 'Device Management',
  'menu.idc.template': 'Device Template',
  'menu.idc.pdu': 'PDU Device',
  'menu.network': 'Network Management',
  'menu.network.connection': 'Connection Management',
  'menu.network.port': 'Port Configuration',
  'menu.network.topology': 'Network Topology',
  'menu.monitor': 'Monitor Center',
  'menu.monitor.environment': 'Environment Monitor',
  'menu.monitor.alert': 'Alert Center',
  'menu.monitor.alert.rules': 'Alert Rules',
  'menu.monitor.alert.history': 'Alert History',
  'menu.power': 'Power Management',
  'menu.system': 'System',
  'menu.system.users': 'User Management',
};
